import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';

const HomePageHeader = ({ useDarkMode, setUseDarkMode }) => (
  <div style={{
    width: '100%',
    padding: '0.5rem 1rem',
    textAlign: 'left',
    background: 'var(--slds-g-color-palette-electric-blue-20)',
    borderBottom: '1px solid var(--slds-g-color-border-1, #e0e0e0)',
    color: '#fff',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }}>
    <h1 style={{margin: 0, fontWeight: 400, fontSize: '1.25rem'}}>SLDS2 Theme Builder</h1>
    <div className='color-mode-controls' style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <span className="slds-m-right_x-small pi pi-sun" title="Light"></span>
      <InputSwitch 
        checked={useDarkMode} 
        onChange={(e) => setUseDarkMode(e.value)}
      />
      <span className="slds-m-left_x-small pi pi-moon" title="Dark"></span>
    </div>
  </div>
);

export default HomePageHeader; 